import React from 'react'
import { Link } from 'react-router-dom'

function Header() {
    return (
        <>
          {/*   <div className="preloader">
                <div className="loading-container">
                    <div className="loading"></div>
                    <div id="loading-icon"><img src="/assets/images/loader.svg" alt="" /></div>
                </div>
            </div> */}

            <header className="main-header bg-section">
                <div className="header-sticky">
                    <nav className="navbar navbar-expand-lg">
                        <div className="container-fluid">

                            <Link className="navbar-brand" to="/">
                                <img src="/assets/logo/innosutra_light-v2.1.png" alt="Logo"
                                    style={{
                                        width: '40%'
                                    }}
                                />
                            </Link>

                            <div className="collapse navbar-collapse main-menu">
                                <div className="nav-menu-wrapper">
                                    <ul className="navbar-nav mr-auto" id="menu">
                                        <li className="nav-item"><Link to="/" className="nav-link">Home</Link></li>
                                            {/* <ul>
                        <li className="nav-item"><Link className="nav-link" to="index-2.html">Home - Main</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="index-image.html">Home - Image</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="index-video.html">Home - Video</Link></li>
                      </ul> */}
                                       
                                        <li className="nav-item"><Link to="/about" className="nav-link" >About Us</Link></li>
                                        <li className="nav-item"><Link className="nav-link" to="/services">Services</Link>
                                            {/* <ul>
                                                <li className="nav-item"><Link className="nav-link" to="service-single.html">AI Model Development</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="blog-single.html">AI-Powered Solutions</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="projects.html">AI-Powered Chatbots</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="project-single.html">Mobile App Development</Link></li>
                                                <li className="nav-item"><Link className="nav-link" to="team.html">Web Development</Link></li>
                                            </ul> */}
                                        </li>

                                        <li className="nav-item"><Link className="nav-link" to="/blog">Blog</Link></li>
                                        {/*  <li className="nav-item submenu"><Link className="nav-link" to="#">Pages</Link>
                      <ul>
                        <li className="nav-item"><Link className="nav-link" to="service-single.html">Service Details</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="blog-single.html">Blog Details</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="projects.html">Projects</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="project-single.html">Projects details</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="team.html">Our Team</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="team-single.html">Team Details</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="pricing.html">Our Pricing</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="testimonials.html">Testimonials</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="image-gallery.html">Image Gallery</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="video-gallery.html">Video Gallery</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="faqs.html">FAQs</Link></li>
                        <li className="nav-item"><Link className="nav-link" to="404.html">404</Link></li>
                      </ul>
                    </li> */}
                                        <li className="nav-item">    <Link className="nav-link" to="/contact">Contact Us</Link></li>
                                    </ul>
                                </div>


                                <div className="header-btn">
                                    <Link to="/contact" className="btn-default">Get Started</Link>
                                </div>

                            </div>

                            <div className="navbar-toggle"></div>
                        </div>
                    </nav>
                    <div className="responsive-menu"></div>
                </div>
            </header>
        </>
    )
}

export default Header
